import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { Button } from "~/components/common/button";

export const ReadFullArticleButton = styled(Button)`
  inline-size: 100%;
  margin-inline-end: 12px;
  padding-block: 15px 14px;

  color: #4585ff;
  font-size: 18px;
  font-family: ${fontRoboto};

  border: 1px solid #4585ff;
  border-radius: 2px;

  background: #ffffff;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;

  margin-block-end: 46px;

  color: #4585ff;

  ${ReadFullArticleButton} {
    background-color: transparent;
  }
`;
